import { memo, useEffect, useState } from 'react';
import Table from '../../components/Table/Table';
import DateInput from '../../components/DateInput/DateInput';
import Filter from '../../components/Filter/Filter';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../components/Filter/Filter.styles';
import TextInput from '../../components/TextInput/TextInput';
import Wrapper from '../../components/Wrapper/Wrapper';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import { useForm } from 'react-hook-form';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../components/SelectOptions/SelectOptions';
import { theme } from '../../styles/theme';
import { useDispatch, useSelector } from 'react-redux';
import StatusContainer from '../../components/StatusContainer/StatusContainer';
import convertObjToArrayEmprestimo from './ConvertObjToArrayEmprestimo';
import { loanFetchAction } from '../../store/fetchActions/loanActions';
import { loanDetailFetchAction } from '../../store/fetchActions/loanDetailActions';
import formatMoney from '../../utils/functions/formatMoneyBRL';
import { LoadingContainer } from '../GerenciarClientes/styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';
import { translateMessage } from '../../utils/functions/translateMessage';
import Information from '../../components/Information/Information';
import useCallFilter from '../../utils/hooks/useCallFilter';
import * as dayjs from 'dayjs';
const { mainColor, secondaryColor, rbmBlack } = theme.colors;

function Emprestimo() {
  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState('');
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [filter, setFilter] = useState({
    search: '',
    DATAINICIAL: '',
    DATAFINAL: '',
    status: 0,
    orderBy: '',
    limit: 10,
    page: 1,
  });

  const { paginationLoan, loadingLoan, messageLoan, dataLoan, errorLoan } =
    useSelector((state) => state.loan);

  const {
    loadingLoanDetail,
    messageLoanDetail,
    dataLoanDetail: { parcelas },
    errorLoanDetail,
  } = useSelector((state) => state.loanDetail);

  const { handleSubmit, control } = useForm({});

  useCallFilter(filterData, setFilter, loanFetchAction, 0, 0);

  const filterTable = (data) => setFilterData(data);

  const pagesOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  useEffect(() => {
    dispatch(loanFetchAction(filter));
  }, [filter.page]);

  const header = [
    {
      id: 'data e hora',
      name: 'DATA/HORA',
      align: 'center',
    },
    { id: 'nome', name: 'NOME', align: 'left' },
    { id: 'numero de parcelas', name: 'NÚMERO DE PARCELAS', align: 'center' },
    { id: 'valor', name: 'VALOR', align: 'right' },
    { id: 'status', name: 'STATUS', align: 'center' },
  ];

  const modalTableheader = [
    {
      id: 'Vencimento',
      name: 'VENCIMENTO',
      align: 'center',
    },
    { id: 'Parcela', name: 'PARCELA', align: 'center' },
    { id: 'Valor', name: 'VALOR', align: 'right' },
    { id: 'status', name: 'STATUS', align: 'center' },
  ];
  const body = dataLoan?.map((loan) => {
    return {
      data: [
        {
          info: loan.DATA_HORA,
          align: 'center',
        },
        {
          info: loan.NOME,
          align: 'left',
        },

        {
          info:
            loan.NUMERO_PARCELA +
            'x' +
            ' R$ ' +
            formatMoney(loan.VALOR_PARCELA),
          align: 'center',
        },
        {
          info: 'R$ ' + formatMoney(loan.VALOR),
          align: 'right',
        },
        {
          info: loan.STATUS ? (
            <StatusContainer
              code={loan.STATUS}
              description={loan.STATUS_DESCRICAO}
            ></StatusContainer>
          ) : (
            '-----'
          ),
          align: 'center',
        },
      ],
      onClick: () => inspectLoan(loan),
    };
  });

  const modalTableBody = parcelas?.map((parcela) => {
    return {
      data: [
        {
          info: dayjs(parcela.vencimento).format(`DD/MM/YYYY`),
          align: 'center',
        },

        {
          info: parcela.numeroParcela,
          align: 'center',
        },
        {
          info: 'R$ ' + formatMoney(parcela.valor),
          align: 'right',
        },
        {
          info: parcela.statusCronograma ? (
            <StatusContainer
              code={parcela.statusCronograma}
              description={parcela.statusCronograma}
            ></StatusContainer>
          ) : (
            '-----'
          ),
        },
      ],
    };
  });

  const inspectLoan = (data) => {
    dispatch(loanDetailFetchAction(data.CODOPERACAO));
    setModalData(convertObjToArrayEmprestimo(data));
    setIsModalInfoOpen(true);
  };
  const closeModalInfo = () => setIsModalInfoOpen(false);

  const arrayStatus = [
    { ID: 1, NOME: 'Aguardando' },
    { ID: 2, NOME: 'Aprovado' },
    { ID: 3, NOME: 'Cancelado' },
    { ID: 4, NOME: 'Vencido' },
  ];

  return (
    <Wrapper title="Empréstimo">
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextInput
                label="Nome ou CPF/CNPJ"
                name={'search'}
                width={'25.042vw'}
                margin={'0 0 0 1.389vw'}
                control={control}
                inputProps={{ role: 'filter-text-input' }}
              />
              <SelectOptions
                control={control}
                options={arrayStatus}
                name={'status'}
                width={'9.528vw'}
                label={'Status'}
                initialValue={0}
                initialName={'Todos'}
              />

              <DateInput
                label="Data de Início"
                name={'DATAINICIAL'}
                margin={'0'}
                width={'3.333vw'}
                control={control}
              />
              <DateInput
                label="Data Final"
                name={'DATAFINAL'}
                width={'3.333vw'}
                control={control}
              />
              <Button
                backgroundColor={secondaryColor}
                width="12.153vw"
                hoverBGColor={mainColor}
                hoverColor={rbmBlack}
                color={'white'}
                type="submit"
                margin={'0 1.389vw 0 0'}
                roleName="button-buscar-boletos"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <h5>Resultados por Página</h5>
              <SelectOptions
                control={control}
                options={pagesOptions}
                name={'limit'}
                margin={'0 0 0 1.875vw'}
                initialValue={10}
                initialName={10}
              />
              <h5>Total de Registros: {paginationLoan?.totalResult}</h5>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingLoan ? (
          <LoadingContainer>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <Table
            loading={loadingLoan}
            error={errorLoan}
            hasPagination={true}
            filter={filter}
            pagination={paginationLoan}
            setFilter={setFilter}
            errorMessage={messageLoan}
            filterTable={filterTable}
            header={header}
            body={body}
            limit={filter.limit}
          />
        )}
        <Modal
          open={isModalInfoOpen}
          close={closeModalInfo}
          title="Detalhes Empréstimo"
          width={'45.889vw'}
        >
          {loadingLoanDetail ? (
            <LoadingContainer marginTop={'1vw'}>
              <CircularProgress size={'5vw'} color="inherit" />
            </LoadingContainer>
          ) : errorLoanDetail ? (
            <h1>{translateMessage(messageLoanDetail)}</h1>
          ) : (
            <>
              <Information data={modalData} />
              <Table header={modalTableheader} body={modalTableBody} />
            </>
          )}
        </Modal>
      </div>
    </Wrapper>
  );
}

export default memo(Emprestimo);
